import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import {
  getGeneralSettingsError,
  getGeneralSettingsSuccess,
  updateGeneralSettingsError,
  updateGeneralSettingsSuccess,
  updPasswordError,
  updPasswordSuccess,
} from './actions'
import {
  GENERAL_SETTINGS_REQUEST_ASYNC,
  UPDATE_GENERAL_SETTINGS_REQUEST,
  UPDATE_PASSWORD_REQUEST,
} from './constants'

const getGeneralSettingsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(GENERAL_SETTINGS_REQUEST_ASYNC.INITIATE, UPDATE_GENERAL_SETTINGS_REQUEST.SUCCESS)
    .mergeMap(() =>
      api.settings
        .getProfileSettings()
        .map((response) => getGeneralSettingsSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(getGeneralSettingsError, error)))
        .takeUntil(action$.ofType(GENERAL_SETTINGS_REQUEST_ASYNC.CANCEL))
    )

const updateGeneralSettingsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(UPDATE_GENERAL_SETTINGS_REQUEST.INITIATE).mergeMap(() =>
    api.settings
      .updateProfileSettings(store.getState().form.ProfileSettingsForm.values)
      .map((response) => updateGeneralSettingsSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(updateGeneralSettingsError, error)))
      .takeUntil(action$.ofType(UPDATE_GENERAL_SETTINGS_REQUEST.CANCEL))
  )

const updPasswordEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(UPDATE_PASSWORD_REQUEST.INITIATE).mergeMap(() =>
    api.settings
      .updPassword(store.getState().form.PasswordForm.values)
      .map((response) => updPasswordSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(updPasswordError, error)))
      .takeUntil(action$.ofType(UPDATE_PASSWORD_REQUEST.CANCEL))
  )

export default combineEpics(getGeneralSettingsEpic, updateGeneralSettingsEpic, updPasswordEpic)
